/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { buttons, textblocks, layouts, forms } from 'seal-ui-components';
import { loginUsingSSO } from '@Actions/authentication';
import SwitchButton from '@Components/UI/SwitchButton/SwitchButton';
import EditForm from '../EditForm';
import LoginContainer from '../../../Login/LoginContainer';
import { OverLaySpinner, LoadingOverLay, SystemActionPanel } from '../SystemItem.style';

const SystemMenuPanel = ({
    id,
    label,
    index,
    sealUrl,
    sealSystems,
    friendlyName,
    option,
    setOption,
    editSealSystem,
    removeSystem,
    checked,
    selectedSystemId,
    toggleAuthType,
    principal,
    isAuthenticated
}) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [errorUsernameMsg, setErrorUsernameMsg] = useState([]);
    const [errorPasswordMsg, setErrorPasswordMsg] = useState([]);

    const { isCheckingSSO, hasSSO } = useSelector(state => state.sso);
    const { isAuthenticating, lastPrincipal, serverResponse } = useSelector(state => state.auth);

    const dispatch = useDispatch();

    const { section, visible } = option;

    useEffect(
        () => {
            if (lastPrincipal && lastPrincipal !== principal) {
                setUsername(lastPrincipal);
            } else if (!isAuthenticating && principal && !username) setUsername(principal);
        },
        [isAuthenticating]
    );

    const DeleteSubmitClickHandler = () => {
        removeSystem(id);
        setOption(() => ({ ...option, visible: false }));
    };

    const DeleteCancelClickHandler = () => {
        setOption(() => ({ ...option, visible: false }));
    };

    const handleSetErrorMessage = (elementName, value) => {
        if (elementName === 'username') {
            setErrorUsernameMsg(!value ? ['Enter a username or email'] : '');
        }

        if (elementName === 'password') {
            setErrorPasswordMsg(!value ? ['Enter a password'] : '');
        }
    };

    const handleValidation = credentials => {
        if (credentials.username) handleSetErrorMessage('username', credentials.username);

        if (credentials.password) handleSetErrorMessage('password', credentials.password);

        if (credentials.id) handleSetErrorMessage(credentials.id, credentials.defaultValue);
    };

    const handleChange = event => {
        const { id: key, value } = event.currentTarget;
        handleValidation({ key, value });

        if (key === 'username') setUsername(value);
        else setPassword(value);
    };

    if (visible) {
        if (section === 'EDIT')
            return (
                <EditForm
                    editSealSystem={editSealSystem}
                    setOption={setOption}
                    option={option}
                    friendlyName={friendlyName}
                    sealSystems={sealSystems}
                    sealUrl={sealUrl}
                    id={id}
                    label={label}
                    index={index}
                />
            );
        if (section === 'DELETE')
            return (
                <SystemActionPanel id="System__div">
                    <textblocks.Text className="delete_question">
                        Are you sure you want to delete this system?
                    </textblocks.Text>
                    <layouts.HorizontalBox>
                        <buttons.Button
                            id={`cancel_system_delete_${index}`}
                            appearance="secondary"
                            size="large"
                            onClick={() => DeleteCancelClickHandler()}
                        >
                            Cancel
                        </buttons.Button>
                        <layouts.BoxSpacer />
                        <buttons.Button
                            id={`confirm_system_delete_${index}`}
                            appearance="primary"
                            size="large"
                            onClick={() => DeleteSubmitClickHandler()}
                        >
                            Yes, Delete
                        </buttons.Button>
                    </layouts.HorizontalBox>
                </SystemActionPanel>
            );
    }

    if (checked && visible) {
        if (section.toLowerCase() === 'sso' || section.toLowerCase() === 'credentials')
            return (
                <SystemActionPanel id="System__div" key={`${id}-system-action`}>
                    <textblocks.Heading4>Login Preferences</textblocks.Heading4>
                    <layouts.HorizontalBox>
                        <SwitchButton
                            id={selectedSystemId}
                            option={option}
                            setOption={setOption}
                            toggleAuthType={toggleAuthType}
                            index={index}
                            hasSSO={sealUrl && hasSSO}
                            isCheckingSSO={sealUrl && isCheckingSSO}
                        >
                            {['SSO', 'CREDENTIALS']}
                        </SwitchButton>
                    </layouts.HorizontalBox>

                    {serverResponse && (
                        <textblocks.Section textAlign="center">
                            <textblocks.Heading3>
                                {`We seem to have a problem signing you in`}
                            </textblocks.Heading3>
                            <p id="error-message-text">{serverResponse.message}</p>
                        </textblocks.Section>
                    )}

                    {section.toLowerCase() === 'credentials' && (
                        <LoginContainer
                            index={index}
                            url={sealUrl}
                            isAuthenticating={isAuthenticating}
                            isAuthenticated={isAuthenticated}
                            username={username}
                            password={password}
                            errorUsernameMsg={errorUsernameMsg}
                            errorPasswordMsg={errorPasswordMsg}
                            handleChange={handleChange}
                            handleValidation={handleValidation}
                        />
                    )}

                    {section.toLowerCase() === 'sso' && (
                        <forms.FormGrid rows={2}>
                            <forms.FormGridFooter row={1}>
                                <forms.FormButton
                                    id={`sign_in_with_sso_${index}`}
                                    disabled={
                                        isAuthenticating || (sealUrl && (!hasSSO || isCheckingSSO))
                                    }
                                    type="submit"
                                    appearance="primary"
                                    size="large"
                                    onClick={() => dispatch(loginUsingSSO())}
                                >
                                    {isAuthenticated
                                        ? 'Logged in with sso'
                                        : 'Login with single sign on'}
                                </forms.FormButton>
                            </forms.FormGridFooter>
                        </forms.FormGrid>
                    )}

                    <LoadingOverLay
                        loading={isAuthenticating ? isAuthenticating.toString() : undefined}
                    >
                        <OverLaySpinner />
                    </LoadingOverLay>
                </SystemActionPanel>
            );
    }

    return null;
};

export default SystemMenuPanel;
